export default __webpack_public_path__ + "static/feature-62ac94b46c1a70b4be840f96c833537f.png";